export default __webpack_public_path__ + "static/media/Image6.5ba1ae13.jpeg";